// FormFrame/fields/FieldDivider.tsx
import * as React from "react"
import type { FieldDef } from "./fieldTypes"

type Props = {
    def: Extract<FieldDef, { type: "divider" }>
}

export function FieldDivider({ def }: Props) {
    const m = def.margin === "sm" ? "my-2" : def.margin === "lg" ? "my-6" : "my-4"
    return <div className={`w-full h-px bg-border ${m}`} />
}
